import messages from './messages';

export const MOVEMENT_TYPE = [
  {label: messages.moveIn, id: 'IN'},
  {label: messages.moveOut, id: 'OUT'},
  {label: messages.moveTransfer, id: 'TRANSFERT'},
];
